<template>
    <BaseDialog
        :dialog="dialog"
        v-on:close_dialog="closeDialog"
        >
        <template v-slot:title>
            <span v-if="!!c_data.instrument_id && !c_data.clone">MODIFICA STRUMENTO</span>
            <span v-else>NUOVO STRUMENTO</span>
        </template>
        <InstrumentEdit
            v-bind:instrument_id="c_data.instrument_id"
            v-bind:client_id="c_data.client_id"
            v-bind:primary="c_data.primary"
            v-bind:location_id="c_data.location_id"
            v-bind:department_id="c_data.department_id"
            v-bind:lock_client="c_data.lock_client"
            v-bind:is_childcomponent="true"
            v-bind:back="``"
            v-bind:org_id="c_data.org_id"
            v-bind:owner_lock="c_data.owner_lock"
            v-bind:clone="c_data.clone"
            v-on:close_dialog="closeDialog"
            v-on:update_instrument="updateInstrument"
            ref="instrument_edit" />
    </BaseDialog>
</template>

<script>
// import _ from 'lodash'
import InstrumentEdit from "../instruments/InstrumentEdit_new"
import BaseDialog from '../../components/dialogs/BaseDialog'
export default {
    components: {InstrumentEdit, BaseDialog},
    props: {
        client_id: {
            type: String,
            required: false,
            default: null
        },
        location_id: {
            type: String,
            required: false,
            default: null
        },
        client_name: {
            type: String,
            required: false,
            default: null
        },
        primary: {
            type: Boolean,
            required: false,
            default: false
        },
        org_id: {
            type: String,
            required: false,
            default: null
        },
        instrument_id: {
            type: String,
            required: false,
            default: null
        },
        clone: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data(){
        return {
            dialog: false,
            o_data: {
                instrument_id: null,
                client_id: null,
                location_id: null,
                client_name: null,
                primary: false,
                org_id: null,
                lock_client: false,
                owner_lock: false,
                clone: false
            },
            c_data: {}
        }
    },
    methods: {
        closeDialog(){
            this.$refs.instrument_edit.clear()
            this.dialog = false;
        },
        async openDialog(data){
            this.dialog = true;
            this.c_data = Object.assign({},this.o_data, data)
            console.log("opens dialog C_DATA", this.$refs, this.c_data)
            this.$nextTick(function(){
                this.$refs.instrument_edit.initInstrument()
            })
            
            
        },
        updateInstrument(instr_id) {
            this.$emit('update_instrument', instr_id)
            this.closeDialog()
        }

    },
}
</script>

<style>

</style>
